import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { GungFlow } from '../../../state/flow/types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'lib-gung-flows-table',
    templateUrl: './gung-flows-table.component.html',
    styleUrls: ['./gung-flows-table.component.css'],
    standalone: false
})
export class GungFlowsTableComponent extends ListItemRendererComponent<GungFlow[]> implements OnInit, AfterViewInit {
  constructor(public router: Router, protected modalService: NgbModal) {
    super();
  }

  public ngOnInit() {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  showDetails(flowId): void {
    this.router.navigate(['/admin/gung-flow-details/' + flowId]);
  }
}
